import { render } from "./Profile.vue?vue&type=template&id=ba094ea2&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=ba094ea2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba094ea2"

export default script